/*
 Formularz
 wykorzystano bibliotekę Formik
 
 historia:
  2019-04-19 (JW): pierwsza wersja na podstawie formularza Smarty
*/
// https://bit.dev/mui-org/material-ui/dialog-content
// https://material-ui.com/api/dialog/
// https://material-ui.com/demos/buttons/
//
import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from "@material-ui/core/DialogContentText";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles, Theme, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';

import { Formik, Form, FormikProps, FormikTouched, FormikErrors } from 'formik';

import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';

import { connect, Provider } from 'react-redux';

import NotifierOptions from '../unused/DialogRemarks';

import PrefixPicker, { getPrefix } from '../common/PrefixPicker';
import { FieldTypes, FormFields, renderFields } from '../common/formFields/renderFields';
import { PoleDlugosciJednoWWierszu, mobileBreakpoint } from '../common/formFields/formularzStaleWspolne';
import { FormikTextFieldProps } from '../common/formFields/FormikTextField';

import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from '@date-io/date-fns';

import NoteIcon from '@material-ui/icons/Note';

import theme from '../../themes/themes';
import themeBlue from '../../themes/themesBlue';
import themeGreen from '../../themes/themesGreen';
import themeBrownLight from '../../themes/themesBrownLight';
import themeBrownDark from '../../themes/themesBrownDark';

import { AppState, Actions, store, Values, ZapisanyFormularz, IPageState } from '../../appredux';

import { Rezerwacja, Gosc, Result, bookService, telefonService, Prefiks } from '../../api';

import { FormularzLabels, FormikFieldNames } from './formularzStale';

import DialogInfo from '../common/DialogInfo';
import { Content } from '../Notifier';
import { setLocale } from '../common/localeHelpers';
import CONFIG from '../../cfg/config';
import { sendErrorLog, selectTheme, formatDate, capitalizeFirstLetter } from '../common/helpers';
import SvgIcon from '@material-ui/core/SvgIcon';
import DividerTypography from '../common/DividerTypography';
import { Avatar, Box, Grid } from '@material-ui/core';
import AppRegistrationRoundedIcon from '@mui/icons-material/AppRegistrationRounded';
import FormularzFaktura from './FormularzFaktura';
import MuiCheckbox from '../common/formFields/MuiCheckbox';
import { MuiDatePickerProps } from 'app/common/formFields/MuiDatePicker';

import {InputAdornment, IconButton } from '@material-ui/core';
import EventIcon from '@mui/icons-material/Event';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import ReactDOM from 'react-dom';
import Klawiatura from 'app/common/Klawiatura';

//PM 2021-11-16
//pokoj: string
//zapisanyFormularz: ZapisanyFormularz,
//formularzPicture: string,
type ConfirmDialogProps = {
  page: IPageState,
  // title: string,
  // explanation: string,
  secondaryLight: string,
  secondaryText: string,
  czyPobytZmieniany: boolean,
  lang: string,
  initialValues: Values,
  theme: string,
  zapisanyFormularz: ZapisanyFormularz,
  formularzPicture: string,
  open: boolean,
  openInfo: boolean,
  infoValues: Content[],
  reservation: Rezerwacja,
  fromDate: string,
  toDate: string,
  fromDatePrev: string,
  toDatePrev: string,
  fromDateError: string,
  toDateError: string,
  openError: boolean,
  persons: number,
  width: number,
  roomPrice: () => number,
  closeDialogInfo?: () => void,
  handleSend: (values: Values, cena_pokoj: number) => Promise<void>,
  submitDialogInfo?: () => Promise<void>,
  handleCloseWithoutModal: () => Promise<void>,
  leftFields: () => FormFields[],
  closeError: () => void,
  pokojOpis: string,
  pokoj: string,
  rodz_pokoi: string,
  setPart: (p: number) => void,

}

//PM 2021-11-10
//rightFieldsRender: boolean
type ConfirmDialogState = {
  //table: dostepnoscPokoju[],
  //vacantRooms: number,
  anchorEl: Element | ((element: Element) => Element) | null,
  rightFieldsRender: boolean, 
  terms: boolean[],

  dataUr: string | null
}

class ConfirmDialog extends React.Component<WithTranslation & ConfirmDialogProps & WithStyles<typeof styles> & TransProps, ConfirmDialogState> {
  secondaryLight = this.props.secondaryLight;
  textSecondary = this.props.secondaryText;

  disabledAll: boolean  
  // static defaultProps = {
  //   title: ''
  // }

  //PM 2021-11-16
  //rightFieldsRender: props.czyPobytZmieniany || props.zapisanyFormularz.pokoj !== '' ? true : false
  constructor(props: WithTranslation & ConfirmDialogProps & WithStyles<typeof styles> & TransProps) {
    super(props, {});
    this.state = {
      anchorEl: null,
      rightFieldsRender: props.czyPobytZmieniany || props.zapisanyFormularz.pokoj !== '' || CONFIG.hotelKiosk === "1" ? true : false,
      terms: [false, false, false, false],
      dataUr: null,
    }
    this.disabledAll = CONFIG.menu1PobytZmien === "2" && props.czyPobytZmieniany
    //console.log(this.props.page.dateFromFormularz)
    store.dispatch(Actions.pageState.addFcmLogMessage("formularz", 0))
  }

  componentDidMount(){
    if(this.props.page.prefiksy.length === 0)
      this.getPrefiksy()
    if(this.props.page.czarnaLista.length === 0)  
      this.getCzarnaLista()
  }

  // const [prefiksy, czarnaLista] = await Promise.all(
      //   [
      //     await telefonService.dajPrefiksy( {}, {} ),
      //     await telefonService.dajCzarnaListe( {}, {} )
      //   ]);

  getPrefiksy = async () => {
    try {
      let res = await telefonService.dajPrefiksy( {}, {} )
      store.dispatch(Actions.pageState.setPrefiksy(res.result))


    } catch (error) {
        sendErrorLog("0", "-1", 'vscSms/sms/dajSmsPrefiksy')
        await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/dajSmsPrefiksy", 2))
        console.log(error);
    }
}

getCzarnaLista = async () => {
  try {
    let res = await telefonService.dajCzarnaListe( {}, {} )
    store.dispatch(Actions.pageState.setCzarnaLista(res.result))

  } catch (error) {
      sendErrorLog("0", "-1", 'vscSms/sms/dajSmsCzarnaListe')
      await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/dajSmsCzarnaListe", 2))
      console.log(error);
  }
}


  openMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  setPotwierdzona0 = (event: React.ChangeEvent<{ key?: string; checked: boolean }>) => {
    let t = this.state.terms
    t[0] = Boolean(event.target.checked)
    this.setState({ terms: t });
  }

  setPotwierdzona1 = (event: React.ChangeEvent<{ key?: string; checked: boolean }>) => {
    let t = this.state.terms
    t[1] = Boolean(event.target.checked)
    this.setState({ terms: t });
  }

  setPotwierdzona2 = (event: React.ChangeEvent<{ key?: string; checked: boolean }>) => {
    let t = this.state.terms
    t[2] = Boolean(event.target.checked)
    this.setState({ terms: t });
  }
  
  setPotwierdzona3 = (event: React.ChangeEvent<{ key?: string; checked: boolean }>) => {
    let t = this.state.terms
    t[3] = Boolean(event.target.checked)
    this.setState({ terms: t });
  }

  selectItem = async (
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean
    ) => void,
    flag: string,
    prefix: string
  ) => {
    await store.dispatch(Actions.pageState.setLangPhone({ flag: flag, prefix: prefix }));
    setFieldValue('phone', prefix);
    this.setState({ anchorEl: null });
  };

  // dostepnoscDoTabeli(dostepnosc : Dostepnosc ) {
  //   let ctable : dostepnoscPokoju[] = []
  //   for (let  r  of dostepnosc.result) {
  //      ctable.push(
  //        { pokoj: r.pokoj,
  //          opis: r.opis, 
  //          ilosc_miejsc: r.ilosc_miejsc,
  //          ktora_cena: r.ktora_cena,
  //          cena_brak: r.cena_brak,
  //          cena_pokoj: r.cena_brak,
  //          cena_os1: r.cena_os1,
  //          cena_os2: r.cena_os2,
  //          cena_os3: r.cena_os3,
  //          cena_os4: r.cena_os4
  //         }
  //     )
  //   }
  //   this.setState({...this.state, 
  //       table : ctable
  //   });
  //   // setTimeout(function(){      
  //   // }, 1000);    
  // }

  //     async dajDostepnosc() {
  //       bookService.dajDostepnosc(
  //         {
  //           hotelId: CONFIG.hotelID, 
  //           aOperatorId: Number(sessionStorage.getItem("operator_id")),
  //           aRodzPokoi: this.props.page.basket[0].id, 
  //           aDataOd: this.state.fromDate, 
  //           aDataDo: this.state.toDate
  //         }, {}
  //         ) 
  //         .then(
  //           (res : Dostepnosc) => {
  // //                alert(JSON.stringify(res)) 
  //             //this.dostepnoscDoTabeli(res);
  //           }
  //         )        
  //         .catch( (err : any) => {
  // //                  
  // //alert('Błąd odczytu'+JSON.stringify(err) );
  //             console.error
  //            } 
  //         );
  //      }
  /*
  dostepnoscDoTabeli(dostepnosc : Dostepnosc ) {

    let ctable : dostepnoscPokoju[] = []
    for (let  r  of dostepnosc.result) {
      if(r.pokoj === 0)
        continue;

       ctable.push(
         { pokoj: r.pokoj,
           opis: r.opis, 
           ilosc_miejsc: r.ilosc_miejsc,
           ktora_cena: r.ktora_cena,
           cena_brak: r.cena_brak,
           cena_pokoj: r.cena_brak,
           cena_os1: r.cena_os1,
           cena_os2: r.cena_os2,
           cena_os3: r.cena_os3,
           cena_os4: r.cena_os4
          }
      )
    }
    this.setState({...this.state, 
        table : ctable, 
    });
    setTimeout(function(){      
    }, 1000);     
  }

  async dajDostepnosc() {
    bookService.dajDostepnosc(
      {
        hotelId: "Toshiba", 
        aOperatorId: 1, 
        aRodzPokoi: this.props.page.basket[0].id, 
        aDataOd: this.props.page.dateFrom, 
        aDataDo: this.props.page.dateTo
      }, {}
      ) 
      .then(
        (res : Dostepnosc) => {
//                alert(JSON.stringify(res)) 
          this.dostepnoscDoTabeli(res);
        }
      )        
      .catch( (err : any) => {
//                  
//alert('Błąd odczytu'+JSON.stringify(err) );
          console.error
         } 
      );
   }

  componentWillReceiveProps(){
    this.dajDostepnosc();
  }
  */

  // zrezygnowano 2021-02-19 na rzecz getDetails
  // // wykorzystuje getDetails, żeby sprawdzić dostępność, kiedy pobyt jest zmieniany
  // sprawdzDostepnoscZmienianyPobyt = async (aDataOd: Date, aDataDo: Date): Promise<boolean> => {
  //   let wynik = true;
  //   const dajPobytDataOd = new Date(this.props.page.zmienianyPobyt.pobyt_od);
  //   const dajPobytDataDo = new Date(this.props.page.zmienianyPobyt.pobyt_do);

  //   if (sameDayOrEarlier(aDataDo, dajPobytDataOd)) 
  //     wynik = wynik && await this.getDetails(this.formatDate(aDataOd), this.formatDate(aDataDo));
  //   else if (earlier(aDataOd, dajPobytDataOd)) 
  //     wynik = wynik && await this.getDetails(this.formatDate(aDataOd), this.formatDate(dajPobytDataOd));

  //   if (later(aDataOd, dajPobytDataDo)) 
  //     wynik = wynik && await this.getDetails(this.formatDate(aDataOd), this.formatDate(aDataDo));
  //   else if (later(aDataDo, dajPobytDataDo)) 
  //     wynik = wynik && await this.getDetails(this.formatDate(dajPobytDataDo), this.formatDate(aDataDo));

  //   return wynik;
  // }

  // componentDidUpdate(prevProps: ConfirmDialogProps, prevState: any){
  //   if(this.state.toDate !== prevState.toDate || this.state.fromDate !== prevState.fromDate){
  //     this.getDetails();
  //   }   
  // } 

  handleOpenOptions = async (/*setValue: any*/) => {
    //setValue('remarks', ''); 
    //const {t}  = this.props;
    //console.log(this.props.page.openOptions)
    //store.dispatch(Actions.pageState.changeOpenOptions());   
    {/*ReactDOM.render(
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>    
        <NotifierOptions backButtonDescription={t("Abandon")} finishButtonDescription={t("Edit")} selectButtonDescription={t("Choose")} backButtonDescription2={t("Abandon")} title={t("Person")} surname={t("Surname")} phone={t("Phone Number")} remarks={t("Remarks")} />
        </MuiThemeProvider>
      </Provider>,document.getElementById("dialog"))*/}
    await store.dispatch(Actions.pageState.changeOpenOptions());
  }

  openFormularzFaktura = async (/*setValue: any*/) => {
    await store.dispatch(Actions.pageState.changeOpenFormularzFaktura());
  }

  /*handleSend = ( values : Values) => {
    let resdata = new Reservation();
    resdata.hotelId = CONFIG.hotelID;
    resdata.key = CONFIG.apiKey;
    resdata.lang = this.props.page.lang;
    resdata.name = values.name;
    resdata.surname = values.surname;
    resdata.email = values.email;
    resdata.phone = values.phone;
    resdata.remarks = values.remarks;
    resdata.reservations = [];
    this.props.page.basket.map(
      (item: ResBasketItem) => {
        let rr = new ReservRoom();
        rr.check_in=this.props.page.dateFrom;
        rr.check_out=this.props.page.dateTo;
        rr.price=item.price;
        rr.roomCategory=item.id;
        rr.quantity=item.quantity;
        resdata.reservations.push(rr);
      }
    ) 
    store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));
    this.sendReservation(resdata);
  };*/

  // handleDateToChange = (date: any) => {
  //   let mm = date.getMonth() + 1;
  //   let dd = date.getDate();
  //   let a = [date.getFullYear(),"-",
  //           (mm>9 ? '' : '0') + mm,"-",
  //           (dd>9 ? '' : '0') + dd
  //         ].join('');
  //   store.dispatch(Actions.pageState.setDateTo(a));
  // };

  // if (telefon.length > 5 && this.state.asort.tag_08 == "2")
  // setTimeout(() => {
  //   this.getSaldo(telefon, this.state.entranceType.karnet_typ, this.state.entranceType.dod_karnet_typ, setFieldValue);
  // }, 500);

  //PM 2012-11-10
  //usuniecie this.timeout
  onPhoneChange = (
    event: React.ChangeEvent<{ name?: string; value: any }>,
    values: Values,
    setFieldValue: {
      (field: string, value: any, shouldValidate?: boolean): void;
    }) => {
    let telefon: string = event.target.value
    // if(event.target.value.split(" ").join("").length >= 11){ 
    //   let phoneWithoutCountryTab: string[] = event.target.value.split(" ")
    //   if(phoneWithoutCountryTab[0].length === 2 || phoneWithoutCountryTab[0].length === 2 ){
    //     phoneWithoutCountryTab.shift()
    //     telefon = phoneWithoutCountryTab.join("")
    //     console.log(telefon)
    //   }
    // }  

    let tel = ""
    let regex = /[0-9]/g;
    let found = telefon.match(regex);
    if(found) tel = found.join("")
    //telefon = telefon.split(" ").join("");
    setFieldValue('phone', tel)

    if (values.name === "" && values.email === "" && tel.length > 8) {
      //if (telefon.length > 8){
      setTimeout(async () => {
        await this.getGuestData(tel, setFieldValue);
      }, 500);
    }
  }

  //SW 2012-09-17
  async getGuestData(
    telefon: string,
    setFieldValue: {
      (field: string, value: any, shouldValidate?: boolean): void;
    }) {

    try {
      const res: Result<Gosc> = await bookService.dajGosc({
        hotelId: CONFIG.hotelID,
        aOperatorId: Number(sessionStorage.getItem("operator_id")),
        aTelefon: telefon.replace(/\s/g, "")
      }, {})
      if (res.result.length > 0) {
        let imieINazwisko = res.result[0].nazwisko
        //let imieINazwiskoTab = imieINazwisko.split(" ")
        //if (imieINazwiskoTab.length === 2) {
        //  setFieldValue("name", imieINazwiskoTab[1])
        //  setFieldValue("surname", imieINazwiskoTab[0])
        //} else {
          setFieldValue("name", imieINazwisko)
        //}
        setFieldValue("email", res.result[0].e_mail)

        store.dispatch(Actions.pageState.setGuest(res.result[0]))
      }
    } catch (error) {
      await sendErrorLog("0", "-1", '/manager/dajGoscDlaTelefon')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajGoscDlaTelefon", 2))
      console.log(error)
    }
  }

  handleDateChange = async (dateParam: MaterialUiPickersDate) => {
    if (dateParam) {
        const date = new Date(dateParam.toISOString());

        this.setState({ ...this.setState, dataUr: formatDate(date) });
    }
};

setDate = async (
  dateParam: MaterialUiPickersDate, 
  values: Values,
  setFieldValue: {
    (field: string, value: any, shouldValidate?: boolean): void
  }) => {
  if (dateParam) {
      const date = new Date(dateParam.toISOString());

      this.setState({ ...this.setState, dataUr: formatDate(date) });
      setFieldValue('dataUrodzenia', formatDate(date))
  }
};

openKlawiaturaTel = (val: string, name: string, email: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
  const { t, classes } = this.props;
  
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"number"} placeholder={t(FormularzLabels.Telefon)} onConfirm={(val: string) => {setFieldValue(FormikFieldNames.Telefon, val); if (name === "" && email === "" && val.length > 8) {this.getGuestData(val, setFieldValue)}  }} /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}
openKlawiaturaImie = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
  const { t, classes } = this.props;
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"default"} uppercase placeholder={t("Full name")} onConfirm={(val: string) => setFieldValue(FormikFieldNames.Imie, val)} /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}
openKlawiaturaEmail = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
  const { t, classes } = this.props;
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"default"} placeholder={t(FormularzLabels.Email)} onConfirm={(val: string) => setFieldValue(FormikFieldNames.Email, val)} /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}
openKlawiaturaDokument = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
  const { t, classes } = this.props;
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"default"} uppercase placeholder={t("Dokument")} onConfirm={(val: string) => setFieldValue(FormikFieldNames.Dowod, val)} /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}
openKlawiaturaAdres = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
  const { t, classes } = this.props;
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"default"} uppercase placeholder={t("Address")} onConfirm={(val: string) => setFieldValue(FormikFieldNames.Adres, val)} /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}
openKlawiaturaIR = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
  const { t, classes } = this.props;
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"default"} uppercase placeholder={t("Imiona rodziców")} onConfirm={(val: string) => setFieldValue(FormikFieldNames.ImoinaRodzicow, val)} /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}
openKlawiaturaMU = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
  const { t, classes } = this.props;
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"default"} uppercase placeholder={t("Miejsce urodzenia")} onConfirm={(val: string) => setFieldValue(FormikFieldNames.MiejsceUrodzenia, val)} /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}

  //PM 2021-11-16
  //completed
  rightFields = (
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean
    ) => void,
    values: Values,
    handleChange: (e: React.ChangeEvent<any>) => void,
    touched: FormikTouched<Values>,
    errors: FormikErrors<Values>
  ): FormFields[] => {
    const { t, classes } = this.props;
    const zapisanyFormularz = this.props.zapisanyFormularz.pokoj !== ''

    let fields =  [
      {
        block:
        {
          type: FieldTypes.formikText,
          props: {
            type: "tel",
            key: t(FormularzLabels.Telefon),
            formControlStyle: { marginTop: '20px', },
            label: t(FormularzLabels.Telefon) + '',
            labelClasses: `${classes.primary} ${classes.labelAlign}`,
            required: true,
            name: FormikFieldNames.Telefon,
            //placeholder: "48 123123123",
            style: { width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
            inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.inputPhone}`,
            completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.phone),
            value: values.phone,
            autoFocus: CONFIG.hotelKiosk === "1" ? false : true,
            startAdornment: (
              <PrefixPicker
                anchorEl={this.state.anchorEl}
                openMenu={this.openMenu} setFieldValue={setFieldValue}
                closeMenu={this.closeMenu} selectItem={this.selectItem}
                disabled={this.disabledAll}
              />
            ),
            onChange: (e: React.ChangeEvent<{ name?: string; value: any }>) => { handleChange(e); this.onPhoneChange(e, values, setFieldValue) },
            onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaTel(values.phone, values.name, values.email, setFieldValue) : null,
            touched: touched.phone,
            error: errors.phone,
            disabled: this.disabledAll,
          } as FormikTextFieldProps,
        },
      },
      // {
      //   block:
      //   {
      //     type: FieldTypes.formikText,
      //     props: {
      //       key: t(FormularzLabels.Nazwisko),
      //       label: t(FormularzLabels.Nazwisko) + '',
      //       labelClasses: classes.primary,
      //       required: true,
      //       name: FormikFieldNames.Nazwisko,
      //       //autoFocus: true,
      //       style: {
      //         width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
      //       },
      //       inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.uppercase} ${classes.fontWeightNormal}`,
      //       completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.surname),
      //       value: values.surname,
      //       onChange: handleChange,
      //       touched: touched.surname,
      //       error: errors.surname,
      //       disabled: this.disabledAll,
      //     } as FormikTextFieldProps,
      //   },
      // },
      {
        block:
        {
          type: FieldTypes.formikText,
          props: {
            key: t(FormularzLabels.Imie),
            label: t("Full name1") + '',
            labelClasses: `${classes.primary} ${classes.labelAlign}`,
            required: true,
            name: FormikFieldNames.Imie,
            placeholder: "Nowak Jan",
            style: {
              width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
            },
            inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.uppercase}`, // ${classes.uppercase}
            completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.name),
            value: values.name,
            onChange: handleChange,
            onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaImie(values.name, setFieldValue) : null,
            touched: touched.name,
            error: errors.name,
            disabled: this.disabledAll,
          } as FormikTextFieldProps,
        },
      },
      {
        block:
        {
          type: FieldTypes.formikText,
          props: {
            key: t(FormularzLabels.Email),
            label: t(FormularzLabels.Email) + '',
            labelClasses: `${classes.primary} ${classes.labelAlign}`,
            formControlStyle:{ marginBottom: "30px" },
            //required: true,
            name: FormikFieldNames.Email,
            placeholder: "nowakjan@mail.pl",
            style: { width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
            inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.lowercase}`,
            completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.email),
            value: values.email,
            onChange: handleChange,
            onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaEmail(values.email, setFieldValue) : null,
            touched: touched.email,
            error: errors.email,
            disabled: this.disabledAll,
          } as FormikTextFieldProps,
        },
      },
    ];



    if(CONFIG.hotelKiosk === "1"){
      fields.push(
        {
          block:
          {
            type: FieldTypes.formikText,
            props: {
              key: t("Dowod"),
              label: t("Dokument") + '',
              labelClasses: `${classes.primary} ${classes.labelAlign}`,
              required: CONFIG.hotelKioskDowodNr === "1" ? true : false,
              name: FormikFieldNames.Dowod,
              placeholder: "ABC 123456",
              style: { width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
              inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.uppercase}`,
              completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.dowod),
              value: values.dowod,
              onChange: handleChange,
              onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaDokument(values.dowod, setFieldValue) : null,
              touched: touched.dowod,
              error: errors.dowod,
              disabled: this.disabledAll,
            } as FormikTextFieldProps,
          },
        },
        {
          block:
          {
            type: FieldTypes.formikText,
            props: {
              key: t("Adres"),
              label: capitalizeFirstLetter(t("Address")) + '',
              labelClasses: `${classes.primary} ${classes.labelAlign}`,
              formControlStyle:{ marginBottom: "30px" },
              required: CONFIG.hotelKioskAdres === "1" ? true : false,
              name: FormikFieldNames.Adres,
              placeholder: "Piłsudskiego 12, Tarnów",
              style: { width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
              inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.uppercase}`,
              completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.adres),
              value: values.adres,
              onChange: handleChange,
              onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaAdres(values.adres, setFieldValue) : null,
              touched: touched.adres,
              error: errors.adres,
              disabled: this.disabledAll,
            } as FormikTextFieldProps,
          },
        },
        {
          block:
          {
            type: FieldTypes.formikText,
            props: {
              key: t("Imiona Rodzicow"),
              label: t("Imiona rodziców") + '',
              labelClasses: `${classes.primary} ${classes.labelAlign}`,
              required: CONFIG.hotelKioskImionaRodz === "1" ? true : false,
              name: FormikFieldNames.ImoinaRodzicow,
              placeholder: "Adam Ewa",
              style: { width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
              inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.uppercase}`,
              completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.rodzice),
              value: values.rodzice,
              onChange: handleChange,
              onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaIR(values.rodzice, setFieldValue) : null,
              touched: touched.rodzice,
              error: errors.rodzice,
              disabled: this.disabledAll,
            } as FormikTextFieldProps,
          },
        },
        {
          block:
          {
            type: FieldTypes.date,
            props: {
              key: t("Data Urodzenia"),
              label: t("Data urodzenia") + '',
              labelClasses: `${classes.primary} ${classes.labelAlign}`,
              required: CONFIG.hotelKioskDataUr === "1" ? true : false,
              name: FormikFieldNames.DataUrodzenia,
              placeholder: "1990-01-02",
              style: { width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
              inputClasses: `${classes.textSecondary} ${classes.floatLeft}  ${classes.textAlignLeft} ${classes.fontWeightNormal}`,
              completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.dataUrodzenia),
              value: values.dataUrodzenia === "" ?  null : values.dataUrodzenia,
              touched: touched.dataUrodzenia,
              error: errors.dataUrodzenia,
              disabled: this.disabledAll,

              onChange: this.handleDateChange,
              //onChange: (e: React.ChangeEvent<{ name?: string; value: any }>) => { handleChange(e); this.onPhoneChange(e, values, setFieldValue) },
              //onChange: () => {}, //this.handleDateFromChange,
              //onAccept: this.setDate, //this.setDateFrom,
              onAccept: (date: MaterialUiPickersDate) => {this.setDate(date, values, setFieldValue)}, //handleChange, //this.setDateFrom,
              maxDate:  new Date(),
              

              onMinus: () => {}, //this.minusDayFrom,
              onPlus: () => {}, //this.plusDayFrom,
              cancelLabel: t("Back"),
              formatNoDays: true,
              //showTodayButton: true,
              //todayLabel: t("Today"),
              noArrows: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <EventIcon />
                  </IconButton>
                </InputAdornment>
              ),
            } as MuiDatePickerProps,
          },
        },
        {
          block:
          {
            type: FieldTypes.formikText,
            props: {
              key: t("Miejsce Urodzenia"),
              label: t("Miejsce urodzenia") + '',
              labelClasses: `${classes.primary} ${classes.labelAlign}`,
              required: CONFIG.hotelKioskMscUr === "1" ? true : false,
              name: FormikFieldNames.MiejsceUrodzenia,
              placeholder: "Tarnów",
              style: { width: this.props.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
              inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.uppercase}`,
              completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.miejsceUrodzenia),
              value: values.miejsceUrodzenia,
              onChange: handleChange,
              onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaMU(values.miejsceUrodzenia, setFieldValue) : null,
              touched: touched.miejsceUrodzenia,
              error: errors.miejsceUrodzenia,
              disabled: this.disabledAll,
            } as FormikTextFieldProps,
          },
        },
      )
    }


    return fields
  }

  //PM 2021-11-10
  rightFieldsRender = (
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean
    ) => void,
    values: Values,
    handleChange: (e: React.ChangeEvent<any>) => void,
    touched: FormikTouched<Values>,
    errors: FormikErrors<Values>
  ) => {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {renderFields(this.rightFields(setFieldValue, values, handleChange, touched, errors))}
        {/* <FormControl
          variant="outlined" margin="normal" fullWidth
          className={classes.formControl} style={{ marginTop: '24px' }}
        >
          <label className={classes.label} style={{ float: 'left', width: '21%' }}>
            <Trans>Remarks2</Trans></label>
          <Button color="primary" variant="outlined"
            className={`${classes.button}`}
            type="button"
            style={{ width: "9%" }}
            onClick={() => this.handleOpenOptions()}>
            <NoteIcon style={{ verticalAlign: "middle" }} />
          </Button>
        
        </FormControl> */}
        
          {/*<Field id="4" name="remarks" style={{ float: 'left', width: this.state.width <= mobileBreakpoint? '67%' : '76%' }} className={classes.textField}
              component={TextField} multiline="true" rows="3" rowsMax="5" variant="outlined" inputProps={{style: styleInputow[4]}}
      InputProps={{classes: {input: `${classes.textSecondary}`}}}/>*/}
      
        {/* <FormControl
          variant="outlined" margin="normal" fullWidth
          className={classes.formControl} style={{ marginTop: '10px' }}
        >
          <label className={`${classes.label} ${classes.primary}`} style={{ float: 'left', width: '21%' }}>
            <Trans>Invoice data</Trans></label>
          <Button color="primary" variant="outlined"
            className={`${classes.button}`}
            type="button"
            style={{ width: "9%" }}
            onClick={() => this.openFormularzFaktura()}>
            <NoteIcon style={{ verticalAlign: "middle" }} />
          </Button>
        </FormControl> */}

        <Typography className={`${classes.label} ${classes.legend}`} color="error">
          <Trans>Field must be filled</Trans>
        </Typography>
      </React.Fragment>
    )
  }

  //PM 2021-11-18
  oauth2SignInGoogle = () => {
    const zapisanyFormularz: ZapisanyFormularz = {
      dostawca: 'Google',
      pokoj: this.props.pokoj,
      dataOd: this.props.fromDate,
      dataDo: this.props.toDate,
      osob: this.props.persons
    };

    sessionStorage.setItem("zapisanyFormularz", JSON.stringify(zapisanyFormularz));
    //window.open('http://localhost:3000/?redirect_url=http://localhost:3001', '_self')
    window.open(`https://vsc24.net/vscZasady/zasady/Auth/Google/?redirect_url=${window.location.href.split('/hotel')[0]}/hotel/${window.location.pathname.split('/')[3]}`, '_self')
  }

  //PM 2021-11-18
  oauth2SignInFacebook = () => {
    const zapisanyFormularz: ZapisanyFormularz = {
      dostawca: 'Facebook',
      pokoj: this.props.pokoj,
      dataOd: this.props.fromDate,
      dataDo: this.props.toDate,
      osob: this.props.persons
    };

    sessionStorage.setItem("zapisanyFormularz", JSON.stringify(zapisanyFormularz));
    //window.open('http://localhost:3000/?redirect_url=http://localhost:3001', '_self')
    window.open(`https://vsc24.net/vscZasady/zasady/Auth/Facebook/?redirect_url=${window.location.href.split('/hotel')[0]}/hotel/${window.location.pathname.split('/')[3]}`, '_self')
  }

  //PM 2021-11-19
  pobierzLubWpiszDane = () => {
    const { classes } = this.props;

    let disabled = CONFIG.zasady1 === "1" && CONFIG.zasady1Zaznacz === "1" && !this.state.terms[0] 
                || CONFIG.zasady2 === "1" && CONFIG.zasady2Zaznacz === "1" && !this.state.terms[1]
                || CONFIG.zasady3 === "1" && CONFIG.zasady3Zaznacz === "1" && !this.state.terms[2]
                || CONFIG.zasady4 === "1" && CONFIG.zasady4Zaznacz === "1" && !this.state.terms[3]


    let width = (this.props.lang === 'pl') ? '243.875px' 
      : (this.props.lang !== 'de' && this.props.lang !== 'ru') ? '295px' : '340px'

    return (
      <MuiThemeProvider theme={ selectTheme(this.props.theme) }>
        <div  style={{marginTop: '11px'}}>

      <div style={{display: "table", margin: "auto"}}>
      {CONFIG.zasady1 === "1" && CONFIG.zasady1Zaznacz === "1" ? 
      <MuiCheckbox
            formControlStyle={{ marginTop: 0, marginBottom: 0 }}
            key={"0"}
            label={"Przeczytałem i akceptuje " + CONFIG.zasady1Opis}
            labelHTML={<span><Trans>Terms</Trans> <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady1Link}`} target="_blank" rel="noreferrer" className={classes.link}>{CONFIG.zasady1Opis}</a></span>}
            labelClasses={classes.primary}
            //labelStyle={{paddingLeft: "10px"}}
            labelBlock
            color="primary"
            checkboxFirst
            checked={this.state.terms[0]}//{this.state.potwierdzona}
            onChange={this.setPotwierdzona0}
          />
      : null}    
      {CONFIG.zasady2 === "1" && CONFIG.zasady2Zaznacz === "1"  ? 
           <MuiCheckbox
            formControlStyle={{ marginTop: CONFIG.zasady1Zaznacz === "1" ? "-12px" :  "0px", marginBottom: 0  }}
            key={"1"}
            label={"Przeczytałem i akceptuje " + CONFIG.zasady2Opis}
            labelHTML={<span><Trans>Terms</Trans> <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady2Link}`} target="_blank" rel="noreferrer" className={classes.link}>{CONFIG.zasady2Opis}</a></span>}
            //labelStyle={{paddingLeft: "10px"}}
            labelBlock
            color="primary"
            labelClasses={classes.primary}
            checkboxFirst
            checked={this.state.terms[1]}//{this.state.potwierdzona}
            onChange={this.setPotwierdzona1}
          />
      : null}
      {CONFIG.zasady3 === "1" && CONFIG.zasady3Zaznacz === "1"  ? 
           <MuiCheckbox
            formControlStyle={{ marginTop: CONFIG.zasady1Zaznacz === "1" || CONFIG.zasady2Zaznacz === "1" ? "-12px" :  "0px", marginBottom: 0 }}
            key={"2"}
            label={"Przeczytałem i akceptuje " + CONFIG.zasady3Opis}
            labelHTML={<span><Trans>Terms</Trans> <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady3Link}`} target="_blank" rel="noreferrer" className={classes.link}>{CONFIG.zasady3Opis}</a></span>}
            //labelStyle={{paddingLeft: "10px"}}
            labelBlock
            color="primary"
            labelClasses={classes.primary}
            checkboxFirst
            checked={this.state.terms[2]}//{this.state.potwierdzona}
            onChange={this.setPotwierdzona2}
          />
      : null} 
      {CONFIG.zasady4 === "1" && CONFIG.zasady4Zaznacz === "1"  ? 
           <MuiCheckbox
            formControlStyle={{ marginTop: CONFIG.zasady1Zaznacz === "1" || CONFIG.zasady2Zaznacz === "1" ? "-12px" :  "0px", marginBottom: 0 }}
            key={"2"}
            label={"Przeczytałem i akceptuje " + CONFIG.zasady3Opis}
            labelHTML={<span><Trans>Terms</Trans> <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady4Link}`} target="_blank" rel="noreferrer" className={classes.link}>{CONFIG.zasady4Opis}</a></span>}
            //labelStyle={{paddingLeft: "10px"}}
            labelBlock
            color="primary"
            labelClasses={classes.primary}
            checkboxFirst
            checked={this.state.terms[3]}//{this.state.potwierdzona}
            onChange={this.setPotwierdzona3}
          />
      : null} 
      </div> 

        <div style={{display: "flex", justifyContent: "center", marginTop: "12px", marginBottom: "50px",
      alignItems: CONFIG.zasady1 === "1" && CONFIG.zasady1Zaznacz === "1"  || CONFIG.zasady2 === "1" && CONFIG.zasady2Zaznacz === "1" || CONFIG.zasady3 === "1" && CONFIG.zasady3Zaznacz === "1" || CONFIG.zasady4 === "1" && CONFIG.zasady4Zaznacz === "1"  ? "normal" : "center",  
      minHeight:  CONFIG.zasady1 === "1" && CONFIG.zasady1Zaznacz === "1"  || CONFIG.zasady2 === "1" && CONFIG.zasady2Zaznacz === "1" || CONFIG.zasady3 === "1" && CONFIG.zasady3Zaznacz === "1" || CONFIG.zasady4 === "1" && CONFIG.zasady4Zaznacz === "1"  ? "0" : "265px" }}> 
        <Box sx={{ width: width }}>
          <div className={classes.marginProvider}>
            <Button
              variant='outlined'
              color='primary'
              disabled={disabled}
              startIcon={
                <SvgIcon className={classes.icon}>
                  <image width="24" height="24" x="0" y="0" href="img/ikonki/f_logo_RGB-Blue_58.png" />
                </SvgIcon>
              }
              className={`${classes.transformNone} ${classes.justifyStart}`}
              onClick={this.oauth2SignInFacebook}
              fullWidth
            >
              <b><Trans>Fill in your data from Facebook</Trans></b>
            </Button>
          </div>
          <div>
            <Button
              variant='outlined'
              color='primary'
              disabled={disabled}
              startIcon={
                <SvgIcon className={classes.icon}>
                  <image
                    width="24" height="24" x="0" y="0"
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABvFBMVEUAAADzlovzl5D0lpD0nZL/AADzlo7vfnTqW07pTkHvcGXxjoX/mZn1mpHweW3sW0/ykoj0lo/rWU3yi4Hzl4/qUEPsXFHynZfumZntXFHtYVbwhn3zkov0lY3wj4budW3sW1DznJbxf3fwioPymZHscmjzmpT+2nb4vzXxlIv61WHvf3b6zEP1rU33l5eTtfiRu/mQuvj6wyT6yTphmvRfl/P5vhT8zlBRjvP5vhX80FBimPROjvP6xCX6yDlhl/RWkfP6zEKVwWyU1aSWvfmWuvhalPRonvX71mdywoiWuvp+qvf+4X/MxUmEy5iqqv9tofaVu/l3xY58yJEAf3+R0aN5rOZimvQA//+Z3apStG1RtWt7xo+Hy5mJy5uByJRuwoVBrF6UufeTz6NFsGGCrviT0qZMs2mDvrSY1qNvwYVGsWSIy5mU0KV4xYpTtm1BrF1iu3qDypeR2qOc17CY0qWW0Kah1q4A/wDqQzXqRDfrSDvrSjzuZUPqRTf7vAX7vxTzik1ChfT4vQjpvx5num40qFNDhvRIsGE2qVQ6qlhIsGddn9NDhfQ4qlZpsLRChfM3qVY2qVX///8ORGZaAAAAeXRSTlMAFkVMLwFCyPn+5YgFHNT3Z0f6kkD9+CoP9/WtbF6J1/gsvps/4Ssc/XWgxOP9ICYxJfnq8/b+zvz+z/T9+ev0+uL9H11z+e2exjjEGvx3A+devp4CHNvzAQ/39rBxZIjN/mdA/b5F+cIZ0vyKPMP2/uqbDg05QiYB4SI8PwAAAAFiS0dEk+ED37YAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfjChYVDQdS4VkbAAABJUlEQVQoz2WQZVcDMRBFg7sUd3d3h9LiFNfi7u6kSGCB4PqLmWxIGrrv07x7k5w5QUjGzd3D0wu5xtvHF0P8/AMCVRwU7MAiIaFObgrDShzhgkdEqhxHRf/xmFi9x8UnJCYlX+CUVHEhjeHLdL5QRmaW4Nk5Vxhf5xr2RHnk5hbnGzkqIIQUFuljcYlIKbQyEOX8TIUmUgmtCkS1q6iBVguijot6KRqgNYJo4sIsRTM0CyF31hZdtLaxtIPogNZJ7h9ol3PL7kcQNhh6ep8ofe4TvH+APTXIxiEKeRke0fnoGOPjdjZPTDJDp6ZnZufmF17fNO19kd9eWqZKPj6/VsS7q2uqoet2ucnG5rfEW9v/vnJnd+8H6P7B4ZHhm49PTs/OZfsFP3CBIUV3uckAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMTAtMjNUMDQ6MTM6MDctMDc6MDAoqOkDAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTEwLTIzVDA0OjEzOjA3LTA3OjAwWfVRvwAAAABJRU5ErkJggg=="
                  />
                </SvgIcon>
              }
              className={`${classes.transformNone} ${classes.justifyStart}`}
              onClick={this.oauth2SignInGoogle}
              fullWidth
            >
              <b><Trans>Fill in your data from Google</Trans></b>
            </Button>
          </div>
          <div className={classes.marginDivider}>
            <DividerTypography borderColor={disabled? "rgba(0, 0, 0, 0.12)" : undefined}>
              <span style={{color: disabled? "rgba(0, 0, 0, 0.26)" : undefined }}><Trans>or</Trans></span>
            </DividerTypography>
          </div>
          <div className={`${classes.textCenter} ${classes.marginWpisz}`}>
            <Button
              variant='outlined'
              color='primary'
              disabled={disabled}
              startIcon={<AppRegistrationRoundedIcon className={classes.registrationIcon} />}
              onClick={() => this.setState({ rightFieldsRender: true })}
              className={`${classes.transformNone} ${classes.justifyStart}`}
              fullWidth
            >
              <b><Trans>Enter your data</Trans></b>
            </Button>
          </div>
        </Box>
        </div>

        </div>
      </MuiThemeProvider>
    )
  }

  // phoneCheck1 = async (phone: string) : Promise<string> => {
  //   const { t, classes } = this.props;

  //   if(phone.length < 8){
  //     return t("Invalid phone")
  //   }

  //   try {
  //     let res = await telefonService.sprawdzNrTelefonu( {nrTelefonu: phone}, {} )

  //     if(Number(res.result) > 0){
  //       return ""
  //     }
  //     return t("Invalid phone")

  //   } catch (error) {
  //       sendErrorLog("0", "-1", 'vscSms/sms/sprawdzNrTelefonu')
  //       await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/sprawdzNrTelefonu", 2))
  //       console.log(error);
  //   }
  //   return ""
  // }

  phoneCheck = async (phone: string) : Promise<string> => {
    const { t, classes } = this.props;

    if(phone.length < 8){
      return t("Invalid phone")
    }

    try {
      let res = await telefonService.sprawdzNrTelefonu( {nrTelefonu: phone}, {} )

      if(Number(res.result) > 0){
        //return ""
      } else {
        return t("Invalid phone")
      }
      

    } catch (error) {
        sendErrorLog("0", "-1", 'vscSms/sms/sprawdzNrTelefonu')
        await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/sprawdzNrTelefonu", 2))
        console.log(error);
    }


    if(this.props.page.prefiksy.length > 0){
      let reg = "9,12"

      //wybranie prefiksu
      let prefix = this.props.page.prefiksy.find(x => {
        let p = x.prefiks.substring(1)
        if(p === phone.substring(0, p.length)){
          return x
        }
        return false
      })

     
      if(prefix){
         //znaleziono prefix
        let split = prefix.lbCyfr.split('-')
        if(prefix.lbCyfr.includes('-')){
          reg = `${prefix.prefiks.length -1 + Number(split[0])},${prefix.prefiks.length -1 + Number(split[1])}`
        } else {
          reg = `${prefix.prefiks.length -1 + Number(split[0])}`
        }

        if(prefix.domena == 'pl'){
          //poprawność początku numeru z prefiksem, tylko dla Polski
          
          if (this.poprawnyPolskiNumer(phone, 2, 4)) {
            return t("Invalid phone")
          }
        }

      } else {
       //poprawność początku numeru bez prefiksu, tylko dla Polski
        if(this.poprawnyPolskiNumer(phone, 0, 2)){
          return t("Invalid phone")
        }
       
      }

      //sprawdzenie długości numeru
      let regex = new RegExp(`(^\\d{${reg}}$)`, 'g');
      if (!phone.toString().replace(/\s/g, "").match(regex)) {
        return t("Invalid phone")
      }

    } else {
      //brak tablicy prefiksów, sprawdzenie długości numeru
      let regex = new RegExp(`/(^\\d{9,12}$)/`, 'g');
      if (!phone.toString().replace(/\s/g, "").match(regex)) {
        return t("Invalid phone")
      }
    }


    if(this.props.page.czarnaLista.find((x: {tel: string}) => phone.includes(x.tel))){
      //czarna lista
      return t("Invalid phone")
    }
    
    //poprawny numer
    return ""
  }

  poprawnyPolskiNumer = (phone: string, start: number, end: number): boolean => {
    return !(phone.substring(start, end) === "45" ||
            phone.substring(start, end) === "50" ||
            phone.substring(start, end) === "51" ||
            phone.substring(start, end) === "53" ||
            phone.substring(start, end) === "57" ||
            phone.substring(start, end) === "60" ||
            phone.substring(start, end) === "66" ||
            phone.substring(start, end) === "69" ||
            phone.substring(start, end) === "72" ||
            phone.substring(start, end) === "73" ||
            phone.substring(start, end) === "78" ||
            phone.substring(start, end) === "79" ||
            phone.substring(start, end) === "88")
  }

  czyUsluga = () => {
    let rodz = this.props.rodz_pokoi.toString()
    return (CONFIG.grafikUslugaRodzPok1 == rodz || CONFIG.grafikUslugaRodzPok2 == rodz || CONFIG.grafikUslugaRodzPok3 == rodz
            || CONFIG.grafikUslugaRodzPok4 == rodz || CONFIG.grafikUslugaRodzPok5 == rodz || CONFIG.grafikUslugaRodzPok6 == rodz
            || CONFIG.grafikUslugaRodzPok7 == rodz || CONFIG.grafikUslugaRodzPok8 == rodz || CONFIG.grafikUslugaRodzPok9 == rodz)
    }

  //PM 2021-11-16
  //oauth2
  render() {
    const { t, classes } = this.props;

    //let CopyForMe=t('CopyForMe')
    //let przyjazd=t('CopyForMe').toLowerCase
    //let wyjazd=t('CopyForMe').toLowerCase
    //console.log(this.props.page.theme)

    //console.log(this.secondaryLight)
    /*
            <DialogContentText>
                { this.props.explanation}
            </DialogContentText>
                onClose={this.handleClose}
                <DialogTitle id="responsive-dialog-title">
                { this.props.title }
                </DialogTitle>
    
    */

    return (
      
      <Grid
      
            item
            xs={12}
            md={12}
            style={{ paddingLeft: this.state.width > 600 ? "12px" : "0", minHeight: "500px" }}
          >
                 
                    <Formik
                      initialValues={this.props.initialValues.phone
                        ? this.props.initialValues
                        : {
                          ...this.props.initialValues,
                          phone: getPrefix(this.props.lang) + '',
                        }}
                      validate={async (values) => {
                        let errors = {}
                        if (!values.name) {
                          errors = { ...errors, name: t("Required") };
                        }
                        if (!values.email) { // brak wymogu emaila
                          //errors = { ...errors, email: t("Required") };
                        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email.trim())) {
                          errors = { ...errors, email: t("Invalid") };
                        }
                        let phoneError = await this.phoneCheck(values.phone.toString())
                        //let phoneError = await this.phoneCheck1(values.phone.toString())
                        if(phoneError) {
                          errors = { ...errors, phone: phoneError };
                        }
                        if (!values.phone) {
                          errors = { ...errors, phone: t("Required") };
                        }

                        if(CONFIG.hotelKiosk === "1"){
                          if(CONFIG.hotelKioskAdres  === "1" && !values.adres){
                            errors = { ...errors, adres: t("Required") };
                          }
                          if(CONFIG.hotelKioskDataUr  === "1" && (!values.dataUrodzenia || values.dataUrodzenia === null)){
                            errors = { ...errors, dataUrodzenia: t("Required") };
                          }
                          if(CONFIG.hotelKioskDowodNr  === "1" && !values.dowod){
                            errors = { ...errors, dowod: t("Required") };
                          }
                          if(CONFIG.hotelKioskImionaRodz  === "1" && !values.rodzice){
                            errors = { ...errors, rodzice: t("Required") };
                          }
                          if(CONFIG.hotelKioskMscUr  === "1" && !values.miejsceUrodzenia){
                            errors = { ...errors, miejsceUrodzenia: t("Required") };
                          }
                        }
                        return errors;
                      }}
                      onSubmit={(values, formikActions) => {
                        setTimeout(async () => {
                          //console.log(values)
                          await this.props.handleSend(values, this.props.roomPrice());
                          formikActions.setSubmitting(false)
                          //          formikActions.resetForm()
                        }, 500)
                      }}
                      render={({ submitForm, isSubmitting, values, setFieldValue, handleChange, touched, errors }: FormikProps<Values>) => (
                        <Form className={classes.form} >
                          <Provider store={store}>
                          <MuiThemeProvider theme={ selectTheme(this.props.theme) }>
                              {/* <NotifierOptions values={values} onChange={handleChange} /> */}
                              {/* <FormularzFaktura/> */}
                            </MuiThemeProvider>
                          </Provider>
                          <DialogTitle disableTypography style={{ padding: "0" }}>
                            <Typography variant="h6" component="h2" color="primary" style={{fontSize: "1rem", padding: "2px 8px" }}>
                              <b style={{ fontSize: "11px",textTransform: "uppercase", color: "rgb(182, 59, 77)"  }}><Trans>Guest Details</Trans></b>
                            </Typography>
                            <hr style={{borderStyle: "none none solid none", borderBottom: "1px solid #e0e0e0", marginBlockStart: "2px"}} />
                          </DialogTitle>
                          {this.props.formularzPicture ?
                            (
                              <Avatar src={this.props.formularzPicture} alt={`${this.props.initialValues.name}`} className={classes.avatar} />
                            ) : null}
                          {this.state.rightFieldsRender ? this.rightFieldsRender(setFieldValue, values, handleChange, touched, errors) : this.pobierzLubWpiszDane()}
                          <DialogActions style={CONFIG.hotelKiosk === "0" ? { position: "absolute", bottom: "8px", right: "12px"} : {marginTop: this.props.width > 500 ? "-40px" : "0px"}} //style={this.props.width <= mobileBreakpoint ? {} : { position: "absolute", bottom: "8px", width: "45.54%" }}
                          >
                          {/* <DialogActions style={{ position: "absolute", bottom: "8px", right: "12px"}} > */}
                            <Button variant="outlined" color="primary" size="small"
                              className={classes.actionButtons}
                              onClick={() => this.props.setPart(0)}
                              // onClick={this.props.handleCloseWithoutModal}
                                >
                              <b><Trans>{t(this.czyUsluga() && CONFIG.grafikUslugaOpisAktywny === "1" ? ("wróć " + capitalizeFirstLetter(CONFIG.grafikUslugaOpisOpis)) : this.czyUsluga() ? "back service" : "back room")}</Trans></b>
                            </Button>
                            <Button variant="contained" color="primary" size="small"
                              className={classes.actionButtons}
                              disabled={isSubmitting || !this.state.rightFieldsRender}
                              onClick={submitForm}
                              style={{ marginRight: this.props.width <= mobileBreakpoint ? "0" : "0px" }}
                            >
                      <b><Trans>summary</Trans></b> {/*{ this.props.czyPobytZmieniany ?  "Save" :"Reserve" }*/}
                            </Button>
                          </DialogActions>
                          {this.props.submitDialogInfo && this.props.closeDialogInfo ?
                            <DialogInfo open={this.props.openInfo} okCallback={this.props.submitDialogInfo} cancelCallback={this.props.closeDialogInfo} dialogContent={this.props.infoValues} windowWidth={this.props.width} zmieniany={this.props.czyPobytZmieniany} />
                            :
                            null
                          }
                        </Form>
                      )}
                    />
                  </Grid>

    );
  }
}

//??export default withMobileDialog()(ConfirmDialog);
const styles = (theme: Theme) => ({
  actionButtons: {
    textTransform: "lowercase" as "lowercase"
  },
  form: {
    width: 'calc(100% + -24px)', // Fix IE 11 issue.
    paddingLeft: "24px", 
    marginTop: theme.spacing(1),
    "@media (max-width: 960px)": {
      width: '100%', // Fix IE 11 issue.
      paddingLeft: "0",
    },
  },
  label: {
    //fontFamilly: "sans-serif",
    //fontSize: "small"
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight,
    padding: "7px 0 4px"
  },
  primary: {
    color: theme.palette.primary.main
  },
  // textField: {
  //   marginLeft: "6px",
  //   //marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 200,
  // },
  // headline: {
  //   fontFamily: "\"'Open Sans'\", sans-serif",
  //   lineHeight: "20px",
  //   fontSize: "14px",
  //   fontWeight: 600
  // },
  /*divider: {
    display: "inline-block",
    width: "1px",
    height: "499px",
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    marginTop: "16px",
    marginBottom: "16px",
    marginLeft: "12px",
    marginRight: "12px",
    border: "none"
  },*/
  textSecondary: {
    //color: theme.palette.text.secondary
    color: theme.palette.primary.main
  },
  text: {
    fontSize: "1.07rem"
  },
  floatLeft: {
    float: "left" as "left"
  },
  floatRight: {
    float: "right" as "right"
  },
  textAlignLeft: {
    textAlign: "left" as "left",
  },
  fontWeightNormal: {
    fontWeight: "normal" as "normal"
  },
  button: {
    height: "35px",
    // padding: "6px 8px 5px",
    // lineHeight: "13px",
    // textAlign: "center" as "center",
    // textTransform: "lowercase" as "lowercase",
    // border: "none",
    // color: "white",
    // borderRadius: "4px",
    // boxShadow: "0 2px 2px rgba(0,0,0,.2)",
    // textDecoration: "none",
    // fontWeight: 100,
    // fontSize: "24px",
    // cursor: "pointer",
    // display: "inline-block"
  },
  backgroundWhite: {
    backgroundColor: "#ffffff"
  },
  // dialogContent: {
  //   maxWidth: "1141px",
  //   minWidth: "368px",
  //   paddingLeft: "12px",
  //   paddingRight: "24px",
  //   paddingBottom: "8px"
  // },
  spanOuter: {
    maxWidth: "552px",
    minWidth: "350px",
    width: "100%"
  },
  spanOuterLeft: {
    backgroundColor: "#f9f9f9",
    paddingLeft: "12px"
  },
  legend: {
    padding: "25px 8px 10px 0px"
  },
  dialogPaper: {
    maxHeight: "100%",
    maxWidth: "1177px",
    minWidth: "350px",
  },
  inputPhone: {
    padding: "8px 14px 8px 75px",
    marginLeft: "-71px",
  },
  uppercase: {
    textTransform: "uppercase" as "uppercase",
  },
  lowercase: {
    textTransform: "lowercase" as "lowercase",
  },
  formControl: {
    display: "block",
    //paddingBottom: "35px"
  },
  icon: {
    width: "24px",
    height: "24px"
  },
  transformNone: {
    textTransform: 'none' as 'none'
  },
  textCenter: {
    textAlign: 'center' as 'center'
  },
  marginDivider: {
    marginTop: '7.5px'
  },
  marginWpisz: {
    marginTop: '10.5px'
  },
  avatar: {
    marginTop: '8px',
    marginBottom: '16px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  justifyStart: {
    justifyContent: 'flex-start'
  },
  marginProvider: {
    marginBottom: '10px'
  },
  registrationIcon: {
    width: '24px !important',
    height: '24px !important'
  },
  link: {
    cursor: "pointer",
    textDecoration: "none",
    color: "rgb(0, 128, 128)",
    //"&:hover":{
    //  color: "rgb(6, 92, 92)",
    //}
  },
  labelAlign: {
    padding: "0",
    height: "35px",
    alignContent: "center" as "center",
  }
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
  secondaryLight: state.pageState.secondaryLight,
  secondaryText: state.pageState.secondaryText,
  czyPobytZmieniany: state.pageState.czyPobytZmieniany,
  lang: state.pageState.lang,
  initialValues: state.pageState.initialValues,
  theme: state.pageState.theme,
  zapisanyFormularz: state.pageState.zapisanyFormularz,
  formularzPicture: state.pageState.formularzPicture
});

export default
  connect(mapStateToProps)(withTranslation()(withStyles(styles)(ConfirmDialog)));

/*
const C = withTranslation()(withStyles(styles)(ConfirmDialog))
export default C
*/